
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residential-trash-and-recycling",
      function () {
        return require("private-next-pages/residential-trash-and-recycling/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residential-trash-and-recycling"])
      });
    }
  